var animalsData = [
    {
        id: 0,
        name: "Table Of Contents",
        img: "./images/world.webp",
        text:"This book contains scientifically valid facts about Our amazing World, authenticated by nationally renowned ecologists and zoologists.  It is recommended to narrate internally with the voice of David Attenborough."
    },
    {
        id: 1,
        name: "Bear",
        img: "./images/bear.jpg",
        text:"Bears are found predominantly in campsite areas throughout our world's forests.  You will often see them eating jars of honey, escorting children through jungles, or saving your national parks from wildfires."
    },
    {
        id: 2,
        name: "Shark",
        img: "./images/shark.jpg",
        text:"Sharks get a pretty bad rap (looking at you, Steven).  Here is a list of things that kill more people than sharks: vending machines, selfies, champagne corks, coconuts, and armed toddlers."
    },
    {
        id: 3,
        name: "Chinchilla",
        img: "./images/chinchilla.jpg",
        text:"Chinchillas have the 2nd highest fur density of any animal, behind only the prestigious otter.  Be sure to amaze your friends and colleagues with this factoid at your next work function.  Hey... you're welcome."
    }
]

export default animalsData